<template>
  <div class="columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile">
    <slot/>
    <album-list-item
      v-for="album in albums"
      v-bind:key="album.id"
      v-bind:album="album"
      v-bind:showReleaseDate="showReleaseDate"
    ></album-list-item>
  </div>
</template>

<script>
  import AlbumListItem from '@/components/AlbumListItem'

  export default {
    name: 'AlbumList',
    components: {
      AlbumListItem
    },
    props: {
      albums: {
        type: Array,
        required: true
      },
      showReleaseDate: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
